import React from 'react';
import { RadioButtonFormContainer, RadioButtonFormLabel, RadioButtonFormContent, RadioButtonFormGroup, RadioButtonInputShow, RadioButtonLabel, RadioButtonInput } from './styles'
import { InfoCircleImage, Tooltip, TooltipContent, TooltipTitle } from '../../views/Simulator/PriceValueToSolicitate/styles';
import infoCircle from '../../assets/images/info-circle.svg';

const RadioButtonForm = ({ label, id, radios, name, selected, register, setIdentificationRadioChecked }) => {
  return (
    <RadioButtonFormContainer id="radio-button">
      <RadioButtonFormLabel htmlFor={id}>{label}</RadioButtonFormLabel>
      <RadioButtonFormContent>
        {radios.map((radio, key) => (
          <RadioButtonFormGroup key={key} id={`radio${key}`}>
            <RadioButtonInputShow onClick={() => setIdentificationRadioChecked(radio, name)} selected={radio.value === selected} />
            <RadioButtonInput type="text" ref={register} name={name} defaultValue={selected} id={id+key} />
            <RadioButtonLabel htmlFor={radio.value}>{radio.label}  
            {radio.tooltip &&
            < ><InfoCircleImage src={infoCircle} alt="info" data-tip data-for={`tooltip${key}`} style={{marginLeft: '15px'}}/>
            <Tooltip
            id={`tooltip${key}`}
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
            {radio.tooltipTitle}
            </TooltipTitle>
            <TooltipContent>
            {radio.TooltipContent}
            </TooltipContent>
          </Tooltip></>
            }
          
            
            </RadioButtonLabel>
          </RadioButtonFormGroup>
        ))}
      </RadioButtonFormContent>
    </RadioButtonFormContainer>
  )
}

export default RadioButtonForm
